import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import {DEFAULT_THRESHOLD_NORMAL} from 'constants/layout'
import {noop, omit, get, pipe, getComponentDisplayName} from 'utils'
import DetectThresholds from './detect-thresholds'

export default ({threshold = DEFAULT_THRESHOLD_NORMAL, onChange = noop, expose = 'compact'} = {}) => Wrapped =>
  DetectThresholds({
    thresholds: {compact: threshold},
    defaultThresholds: {
      compact: Array.isArray(threshold) ? threshold.map(() => true): true,
    },
    expose: '_THRESH_',
    onChange: pipe(get('compact'), onChange),
  })((() => {
    class DetectCompact extends PureComponent {
      constructor(props) {
        super(props)
        const compactProp = this.props._THRESH_.compact
        this.state = {
          [expose]: Array.isArray(compactProp) ? compactProp: !!compactProp,
        }
      }
      
      stateFromProps(props) {
        const next = props.hasOwnProperty(expose)
          ? props[expose]
          : Array.isArray(props._THRESH_.compact)
            ? props._THRESH_.compact
            : !!props._THRESH_.compact
        
        if (this.state[expose] !== next) {
          this.setState({[expose]: next})
          onChange(next)
        }
      }
      
      componentDidMount() {
        this.stateFromProps(this.props)
      }
      
      componentWillReceiveProps(nextProps) {
        this.stateFromProps(nextProps)
      }
      
      render() {
        return (
          <Wrapped
            {...{
              ...omit(['_THRESH_'], this.props),
              [expose]: this.state[expose],
              ...(this.props.hasOwnProperty(expose) ? {[expose]: this.props[expose]}: {}),
            }} />
        )
      }
    }
    
    DetectCompact.propTypes = {
      _THRESH_: PropTypes.shape({
        compact: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.bool)]),
      }),
    }
    
    DetectCompact.displayName = `DetectCompact(${getComponentDisplayName(Wrapped)})`
    
    return DetectCompact
  })())



// WEBPACK FOOTER //
// ./src/higher-order-components/detect-compact.jsx